/*eslint-disable*/
import { types } from "../types/types";

export const LoadUser = (result) => ({
  type: types.userLoad,
  payload: result,
});
